<template>
    <div class="rounded my-3 bordered overflow-hidden">
        <div class="bg-spo-light text-darkblue d-flex align-center justify-space-between pa-2 border-b mb-3">
            <div class="text-body-1 font-weight-bold">{{ equipe.get_readable_name() }}</div>
            <v-btn v-if="!buyDossardBourseView" variant="flat" color="red-darken-4" @click="$emit('deleteEquipe')">
                <v-icon icon="mdi-delete"></v-icon>
            </v-btn>
        </div>

        <div class="pa-2 d-flex flex-column sm-gap">
            <v-text-field v-model="equipeNom" prepend-inner-icon="mdi-pencil"
                @change="change_nom_equipe($formRules.equipe(equipe.nom, index, mainStore.bookingSystem.equipes.list))"
                label="Nom de l'équipe" hint="Accepté : Majuscules, chiffres, espaces et certains caractères spéciaux"
                :rules="[$formRules.equipe(equipe.nom, index, mainStore.bookingSystem.equipes.list)]"></v-text-field>

            <!-- Extra fields -->
            <div v-if="equipe.extra_fields.length > 0">
                <v-row>
                    <v-col cols="12" md="6" v-for="(field, fieldIndex) in equipe.extra_fields" :key="fieldIndex">
                        <v-text-field @change="change_extra_fields(field)" v-model="field.value" :label="field.label"
                            :required="field.required"></v-text-field>
                    </v-col>
                </v-row>
            </div>
            <!-- Nombre de coureurs requis -->
            <div class="d-flex justify-space-between align-center flex-wrap sm-gap">
                <div class="font-weight-bold text-darkblue">Nombre de coureurs requis</div>
                <div class="text-darkblue">{{ getEquipeSizeLabel(equipe) }}</div>
            </div>
            <!-- Parcours -->
            <div class="d-flex justify-space-between align-center flex-wrap sm-gap">
                <div class="font-weight-bold text-darkblue">Parcours</div>
                <div class="text-darkblue">{{ equipe.nom_course }}</div>
            </div>
            <div class="d-flex justify-space-between align-center flex-wrap sm-gap">
                <div class="font-weight-bold text-darkblue">Coureurs dans l'équipe</div>
                <div class="d-flex flex-wrap">
                    <v-chip class="ma-1" v-for="coureur in equipe.coureurs" :key="coureur.index">{{
                        get_coureur_name(coureur) }}</v-chip>
                </div>
            </div>

            <div v-if="isEquipeBelowMinimum(equipe)">
                <v-alert border="start" border-color="red-darken-4" class="mb-2">
                    L'équipe n'a pas atteint le minimum de {{ getEquipeSizeMin(equipe) }} coureur(s), il manque encore
                    {{ getEquipeSizeMin(equipe) - equipe.coureurs.length }} coureur(s). En ajoutant un nouveau
                    participant
                    sur
                    ce parcours, il sera automatiquement ajouté à cette équipe.
                </v-alert>
            </div>
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import { useBookingStore } from '@/stores/bookingStore';

export default {
    props: {
        item: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    emits: ['deleteEquipe'],
    computed: {
        ...mapStores(useMainStore, useBookingStore),
        equipe() {
            return this.mainStore.bookingSystem.equipes.list[this.index];
        },
        equipeNom: {
            get() {
                return this.equipe?.nom ?? '';
            },
            set(value) {
                this.equipe.nom = value;
            },
        },
        buyDossardBourseView() {
            return this.$route.name == "BuyDossardBourse";
        }
    },
    methods: {
        change_nom_equipe(verification) {
            if (verification != true) {
                return;
            }
            for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
                const inscription = this.bookingStore.inscriptions[i];
                for (let j = 0; j < this.equipe.coureurs.length; j++) {
                    if (this.equipe.coureurs[j].index == i) {
                        inscription.set_equipe_name(this.equipe.nom);
                    }
                }
            }
        },

        change_extra_fields(field) {
            for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
                const inscription = this.bookingStore.inscriptions[i];
                for (let j = 0; j < this.equipe.coureurs.length; j++) {
                    if (this.equipe.coureurs[j].index == i) {
                        inscription.set_extra_equipe_fields(field);
                    }
                }
            }
        },

        get_coureur_name(coureur) {
            if (coureur.name != "" && coureur.name != " ") {
                return coureur.name;
            }
            return "Coureur  n°" + (coureur.index + 1);
        },

        getEquipeSizeMin(equipe) {
            return equipe.size_min ?? equipe.size;
        },

        getEquipeSizeMax(equipe) {
            return equipe.size_max ?? equipe.size;
        },

        getEquipeSizeLabel(equipe) {
            const min = this.getEquipeSizeMin(equipe);
            const max = this.getEquipeSizeMax(equipe);
            if (equipe.size_variable && min !== max) {
                return `${equipe.coureurs.length} / (${min} à ${max})`;
            }
            return `${equipe.coureurs.length}/${max}`;
        },

        isEquipeBelowMinimum(equipe) {
            return equipe.coureurs.length < this.getEquipeSizeMin(equipe);
        },
    }
}
</script>

<style lang="scss" scoped></style>
